<template>
  <v-select
    v-bind="$attrs"
    :value="value"
    :items="items"
    :item-text="itemTitle"
    :item-value="itemValue"
    :multiple="multiple"
    :return-object="returnObject"
    @input="$emit('input', $event)"
    @change="handleChange"
  >
    <template v-if="multiple" #prepend-inner>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="#FF9D00"
            v-bind="attrs"
            v-on="on"
          >
            {{ prependIcon }}
          </v-icon>
        </template>
        <span>{{ tooltipText }}</span>
      </v-tooltip>
    </template>
    <template
      v-if="multiple && items.length"
      #prepend-item
    >
      <v-list-item
        @click="selectAll"
      >
        <v-list-item-action>
          <v-checkbox
            :indeterminate="someSelected && !allSelected"
            :input-value="allSelected"
          ></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ selectAllLabel }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
  import { numWord } from '@/util/string'

  export default {
    name: 'SelectField',
    emits: ['input', 'change'],
    props: {
      value: [String, Number, Array],
      items: Array,
      allSelected: {
        type: Boolean,
        default: false,
      },
      itemTitle: {
        type: String,
        default: null,
      },
      itemValue: {
        type: String,
        default: null,
      },
      selectAllLabel: {
        type: String,
        default: 'Все',
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      returnObject: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      selectedAll () {
        return this.value?.length === this.items.length
      },
      someSelected () {
        return this.value?.length > 0
      },
      prependIcon () {
        if (this.allSelected) return 'mdi-check-all'
        if (this.someSelected) return 'mdi-check'
        return 'mdi-circle-outline'
      },
      tooltipText () {
        if (this.allSelected) return 'Выбраны все'

        if (this.someSelected) {
          return `${numWord(this.value.length, 'Выбран', 'Выбрано')} ${this.value.length}`
        }

        return 'Не выбраны'
      },
    },
    watch: {
      selectedAll (value) {
        if (value) this.selectAll()
      },
    },
    methods: {
      handleChange (value) {
        if (this.multiple && this.allSelected && value.length) {
          this.$emit('update:allSelected', false)
        }

        this.$emit('change', value)
      },
      selectAll () {
        if (this.allSelected) {
          this.$emit('update:allSelected', false)
        } else {
          this.$emit('update:allSelected', true)
          this.$emit('input', [])
        }

        this.$emit('change')
      },
    },
  }
</script>
